import actions from '../event/event-actions-creator';
import InternalLinkLib from '../../components/shared/internal-link-lib';
import Global from '../../global';
import DP from '../../facades/data-provider';
import { getLogDataFromUserContext } from '../../services/clickstream-service/utils';

export function getEventDetails(eventId) {
  return (dispatch, getState) => {
    const state = getState();
    const { appConfig, userContext } = state;
    const { locale, market, offering } = userContext;
    const { useProdApis } = appConfig;

    const logData = getLogDataFromUserContext(userContext);
    let promise = DP.getEventDetails(eventId, locale, market, offering, logData, useProdApis);

    if (promise) {
      return promise
        .then(eventDetails => {
          dispatch(actions.eventDetailsLoadSuccess(eventDetails));
        })
        .catch(() => {
          dispatch(actions.eventDetailsLoadFailed());
          Global.logger.debug('Redirect to home because of event details error');
          InternalLinkLib.goToInternalRoute('/home');
        });
    }
  };
}
